module.exports = __webpack_public_path__ + "img/loyalty-reward-title.de5ca752.svg";